import React from "react";
import BackButton from "../../components/BackButton/BackButton";
import Whatsapp from "../../img/Whatsapp";
import Button from "../../components/Button/Button";
import Footer from "../../components/Footer/Footer";
import "./styles.css";

function OfferUnsuccess({ onBack, onScheduleClick }) {
  const currentURL = window.location.href;
  const isCelucambio = currentURL.includes('celucambio');
  const isQuieromac = currentURL.includes('quieromac');
  return (
    <div>
      <h1>No podemos hacer una oferta por tu dispositivo.</h1>
      <p className="description">
        <span>
          Por ahora con los detalles que nos diste no podemos brindarte una
          oferta.
        </span>{" "}
        Visítanos en una tienda {isCelucambio &&("Celucambio")} {isQuieromac &&("Quieromac")} o aliada para un segundo vistazo o{" "}
        <span>
          solicita una nueva cotización por WhatsApp con uno de nuestros
          asesores.
        </span>
      </p>
      <div>
        <Button type="black">
          <a
            href="https://wa.me/573118898116"
            target="_blank"
            rel="noopener noreferrer"
            className="talkWhatsapp"
          >
            <div />
            <p>Hablar con un asesor</p>
            <Whatsapp />
          </a>
        </Button>
        <Button type="full" onClick={onScheduleClick}>
          Agendar cita en tienda física
        </Button>
      </div>
      <BackButton onClick={onBack} />
      <Footer />
    </div>
  );
}

export default OfferUnsuccess;
